module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-body"
  }, [_c('h1', {
    staticClass: "pageTitle"
  }, [_vm._v(_vm._s(_vm.$t('pricingAgreements.editPricingAgreement')))]), _vm._v(" "), _c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-width": "140px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('pricingAgreements.customer')
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.agreement.client && _vm.agreement.client.name ? _vm.agreement.client.name : '-'))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('pricingAgreements.name'),
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('pricingAgreements.namePlaceholder')
    },
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('pricingAgreements.validFrom'),
      "required": ""
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "value-format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.form.valid_from),
      callback: function($$v) {
        _vm.$set(_vm.form, "valid_from", $$v)
      },
      expression: "form.valid_from"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('pricingAgreements.validTo'),
      "required": ""
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "value-format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.form.valid_to),
      callback: function($$v) {
        _vm.$set(_vm.form, "valid_to", $$v)
      },
      expression: "form.valid_to"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('pricingAgreements.active')
    }
  }, [_c('el-switch', {
    model: {
      value: (_vm.form.is_active),
      callback: function($$v) {
        _vm.$set(_vm.form, "is_active", $$v)
      },
      expression: "form.is_active"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "loading": _vm.saving
    },
    on: {
      "click": _vm.update
    }
  }, [_vm._v(_vm._s(_vm.$t('pricingAgreements.save')))]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'pricingAgreements.index',
        query: {
          filter: 'active'
        }
      }
    }
  }, [_c('el-button', {
    staticClass: "pricing-agreement-back-btn",
    attrs: {
      "type": "default",
      "size": "small"
    }
  }, [_vm._v(_vm._s(_vm.$t('pricingAgreements.back')))])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "pricing-agreements-toolbar agreement-edit-products-toolbar",
    staticStyle: {
      "margin-bottom": "16px"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10,
      "type": "flex",
      "align": "middle"
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "md": 8
    }
  }, [_c('h2', {
    staticStyle: {
      "margin": "0"
    }
  }, [_vm._v(_vm._s(_vm.$t('pricingAgreements.products')))])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "md": 16
    }
  }, [_c('div', {
    staticClass: "listOptions pricing-agreement-options"
  }, [_c('div', {
    staticClass: "pricing-agreement-options__group pricing-agreement-options__view"
  }, [_c('el-button-group', {
    staticClass: "pricing-agreement-options__view-toggle"
  }, [_c('el-button', {
    attrs: {
      "type": _vm.viewLineMode === 'info' ? 'primary' : 'default',
      "size": "small",
      "icon": "el-icon-menu",
      "round": ""
    },
    on: {
      "click": function($event) {
        return _vm.changeLineView('info')
      }
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": _vm.viewLineMode === 'primary' ? 'primary' : 'default',
      "size": "small",
      "icon": "el-icon-tickets",
      "round": ""
    },
    on: {
      "click": function($event) {
        return _vm.changeLineView('primary')
      }
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "pricing-agreement-options__divider",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pricing-agreement-options__group pricing-agreement-options__filters"
  }, [(_vm.agreementLines.length > 0) ? _c('el-input', {
    staticClass: "pricing-agreement-options__search",
    attrs: {
      "placeholder": _vm.$t('pricingAgreements.searchProductsInAgreement'),
      "clearable": "",
      "prefix-icon": "el-icon-search"
    },
    model: {
      value: (_vm.productSearchQuery),
      callback: function($$v) {
        _vm.productSearchQuery = $$v
      },
      expression: "productSearchQuery"
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "pricing-agreement-options__sort-wrap"
  }, [_c('label', {
    staticClass: "pricing-agreement-options__sort-label"
  }, [_vm._v(_vm._s(_vm.$t('sort.title')))]), _vm._v(" "), _c('v-select', {
    staticClass: "sort pricing-agreement-options__sort",
    attrs: {
      "name": "sortLine",
      "options": _vm.sortLineTypes,
      "value": _vm.sortLine
    },
    on: {
      "change": _vm.onChangeLineSort
    }
  })], 1)], 1)])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "agreement-add-product-wrapper"
  }, [_c('v-card', {
    staticClass: "agreement-product-card agreement-add-product-form"
  }, [_c('el-form', {
    staticClass: "agreement-add-product-form-inner",
    attrs: {
      "model": _vm.newLine,
      "label-position": "top"
    }
  }, [_c('el-form-item', {
    staticClass: "agreement-add-field-product",
    attrs: {
      "label": _vm.$t('pricingAgreements.addProduct')
    }
  }, [_c('el-select', {
    staticClass: "agreement-add-field-input",
    attrs: {
      "filterable": "",
      "remote": "",
      "placeholder": _vm.$t('pricingAgreements.searchProductByName'),
      "remote-method": _vm.remoteProductSearch,
      "loading": _vm.productSearchLoading,
      "clearable": ""
    },
    on: {
      "focus": function($event) {
        _vm.productOptions.length === 0 && _vm.remoteProductSearch('')
      }
    },
    model: {
      value: (_vm.newLine.product_id),
      callback: function($$v) {
        _vm.$set(_vm.newLine, "product_id", $$v)
      },
      expression: "newLine.product_id"
    }
  }, _vm._l((_vm.productOptions), function(p) {
    return _c('el-option', {
      key: p.id,
      attrs: {
        "label": p.number ? p.name + ' (' + p.number + ')' : p.name,
        "value": p.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "agreement-add-field-minqty",
    attrs: {
      "label": _vm.$t('pricingAgreements.minQty')
    }
  }, [_c('el-input', {
    staticClass: "agreement-add-field-input",
    attrs: {
      "type": "number",
      "min": "1"
    },
    model: {
      value: (_vm.newLine.min_qty_or_pack_qty),
      callback: function($$v) {
        _vm.$set(_vm.newLine, "min_qty_or_pack_qty", _vm._n($$v))
      },
      expression: "newLine.min_qty_or_pack_qty"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "agreement-add-field-pct",
    attrs: {
      "label": _vm.$t('pricingAgreements.discountPercent')
    }
  }, [_c('el-input', {
    staticClass: "agreement-add-field-input",
    attrs: {
      "type": "number",
      "placeholder": "%"
    },
    model: {
      value: (_vm.newLine.discount_percent),
      callback: function($$v) {
        _vm.$set(_vm.newLine, "discount_percent", _vm._n($$v))
      },
      expression: "newLine.discount_percent"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "agreement-add-field-amount",
    attrs: {
      "label": _vm.$t('pricingAgreements.discountAmount')
    }
  }, [_c('el-input', {
    staticClass: "agreement-add-field-input",
    attrs: {
      "type": "number",
      "placeholder": _vm.$t('pricingAgreements.perUnit')
    },
    model: {
      value: (_vm.newLine.discount_amount),
      callback: function($$v) {
        _vm.$set(_vm.newLine, "discount_amount", _vm._n($$v))
      },
      expression: "newLine.discount_amount"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "agreement-add-field-comment",
    attrs: {
      "label": _vm.$t('pricingAgreements.comment')
    }
  }, [_c('el-input', {
    staticClass: "agreement-add-field-input",
    attrs: {
      "placeholder": _vm.$t('pricingAgreements.comment')
    },
    model: {
      value: (_vm.newLine.comment),
      callback: function($$v) {
        _vm.$set(_vm.newLine, "comment", $$v)
      },
      expression: "newLine.comment"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "agreement-add-field-button"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.addingLine
    },
    on: {
      "click": _vm.addLine
    }
  }, [_vm._v(_vm._s(_vm.$t('pricingAgreements.addProduct')))])], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.agreementLines.length === 0) ? _c('v-no-data', {
    staticClass: "agreement-products-empty"
  }, [_vm._v("\n    " + _vm._s(_vm.$t('pricingAgreements.noProductsInAgreement')) + "\n  ")]) : (_vm.sortedFilteredAgreementLines.length === 0) ? _c('v-no-data', {
    staticClass: "agreement-products-empty"
  }, [_vm._v("\n    " + _vm._s(_vm.$t('pricingAgreements.noProductsMatchSearch')) + "\n  ")]) : (_vm.viewLineMode === 'info') ? _c('div', {
    staticClass: "flex stretch wrap agreement-products-cards"
  }, _vm._l((_vm.paginatedAgreementLines), function(line, i) {
    return _c('v-card', {
      key: line.id || i,
      staticClass: "agreement-product-card"
    }, [_c('label', {
      staticClass: "cardLabel w-full"
    }, [(line.discount_percent != null) ? _c('span', {
      staticClass: "cardBadge card-green"
    }, [_vm._v(_vm._s(line.discount_percent) + "%")]) : (line.discount_amount != null) ? _c('span', {
      staticClass: "cardBadge"
    }, [_vm._v("Fixed")]) : _c('span', {
      staticClass: "cardBadge"
    }, [_vm._v("–")]), _vm._v(" "), (_vm.isEditingLine(line)) ? [_c('span', {
      staticClass: "agreement-card-actions"
    }, [_c('el-button', {
      attrs: {
        "size": "mini",
        "type": "primary",
        "loading": _vm.savingLine
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.saveLine(line)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('pricingAgreements.save')))]), _vm._v(" "), _c('el-button', {
      attrs: {
        "size": "mini"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.cancelEditLine($event)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('pricingAgreements.cancel')))])], 1)] : [_c('span', {
      staticClass: "agreement-card-actions"
    }, [_c('el-button', {
      attrs: {
        "size": "mini",
        "icon": "el-icon-edit"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.startEditLine(line)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('button.edit')))]), _vm._v(" "), _c('el-button', {
      attrs: {
        "size": "mini",
        "type": "danger",
        "icon": "el-icon-delete"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.deleteLine(line)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('button.delete')))])], 1)]], 2), _vm._v(" "), _c('h2', {
      staticClass: "cardTitle"
    }, [_vm._v(_vm._s(line.product && line.product.name ? line.product.name : _vm.$t('pricingAgreements.productFallback') + line.product_id))]), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.isEditingLine(line)) ? [_c('el-form', {
      staticClass: "agreement-line-edit-form",
      attrs: {
        "label-width": "90px",
        "size": "small"
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": _vm.$t('pricingAgreements.minQty')
      }
    }, [_c('el-input', {
      attrs: {
        "type": "number",
        "min": "1"
      },
      model: {
        value: (_vm.editingForm.min_qty_or_pack_qty),
        callback: function($$v) {
          _vm.$set(_vm.editingForm, "min_qty_or_pack_qty", _vm._n($$v))
        },
        expression: "editingForm.min_qty_or_pack_qty"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": _vm.$t('pricingAgreements.discountPercent')
      }
    }, [_c('el-input', {
      attrs: {
        "type": "number",
        "placeholder": "%"
      },
      model: {
        value: (_vm.editingForm.discount_percent),
        callback: function($$v) {
          _vm.$set(_vm.editingForm, "discount_percent", _vm._n($$v))
        },
        expression: "editingForm.discount_percent"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": _vm.$t('pricingAgreements.discountAmt')
      }
    }, [_c('el-input', {
      attrs: {
        "type": "number",
        "placeholder": _vm.$t('pricingAgreements.perUnit')
      },
      model: {
        value: (_vm.editingForm.discount_amount),
        callback: function($$v) {
          _vm.$set(_vm.editingForm, "discount_amount", _vm._n($$v))
        },
        expression: "editingForm.discount_amount"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": _vm.$t('pricingAgreements.comment')
      }
    }, [_c('el-input', {
      attrs: {
        "type": "textarea",
        "rows": 2,
        "placeholder": _vm.$t('pricingAgreements.comment')
      },
      model: {
        value: (_vm.editingForm.comment),
        callback: function($$v) {
          _vm.$set(_vm.editingForm, "comment", $$v)
        },
        expression: "editingForm.comment"
      }
    })], 1)], 1)] : [_c('label', {
      staticClass: "cardLabel"
    }, [_vm._v(_vm._s(_vm.$t('pricingAgreements.minQty')) + ": ")]), _c('span', {
      staticClass: "cardContent"
    }, [_vm._v(_vm._s(line.min_qty_or_pack_qty))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-top": "8px"
      }
    }, [_c('label', {
      staticClass: "cardLabel"
    }, [_vm._v(_vm._s(_vm.$t('pricingAgreements.discountLabel')) + ": ")]), _vm._v(" "), _c('span', {
      staticClass: "cardContent"
    }, [_vm._v(_vm._s(line.discount_percent != null ? line.discount_percent + '%' : (line.discount_amount != null ? line.discount_amount + ' ' + _vm.$t('pricingAgreements.perUnit') : '–')))])]), _vm._v(" "), (line.comment) ? _c('div', {
      staticClass: "cardinnerBox",
      staticStyle: {
        "margin-top": "10px"
      }
    }, [_c('label', {
      staticClass: "cardLabel cardLabel--small"
    }, [_vm._v(_vm._s(line.comment))])]) : _vm._e()]], 2)
  }), 1) : _c('el-table', {
    staticStyle: {
      "width": "100%",
      "margin-top": "0"
    },
    attrs: {
      "data": _vm.paginatedAgreementLines
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.$t('pricingAgreements.product'),
      "min-width": "220"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n        " + _vm._s(scope.row.product && scope.row.product.name ? scope.row.product.name : _vm.$t('pricingAgreements.productFallback') + scope.row.product_id) + "\n      ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('pricingAgreements.minQty'),
      "prop": "min_qty_or_pack_qty",
      "width": "100",
      "align": "right"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('pricingAgreements.discountLabel'),
      "min-width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.discount_percent != null) ? _c('span', [_vm._v(_vm._s(scope.row.discount_percent) + "%")]) : (scope.row.discount_amount != null) ? _c('span', [_vm._v(_vm._s(scope.row.discount_amount) + " " + _vm._s(_vm.$t('pricingAgreements.perUnit')))]) : _c('span', [_vm._v("–")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('pricingAgreements.comment'),
      "min-width": "160",
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.comment || '–'))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('pricingAgreements.actions'),
      "width": "90",
      "align": "right",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "agreement-table-actions"
        }, [_c('el-button', {
          attrs: {
            "size": "mini",
            "icon": "el-icon-edit"
          },
          on: {
            "click": function($event) {
              return _vm.startEditLine(scope.row)
            }
          }
        }, [_vm._v(_vm._s(_vm.$t('button.edit')))]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "danger",
            "icon": "el-icon-delete"
          },
          on: {
            "click": function($event) {
              return _vm.deleteLine(scope.row)
            }
          }
        }, [_vm._v(_vm._s(_vm.$t('button.delete')))])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('pricingAgreements.editPricingAgreement'),
      "visible": _vm.showTableEditDialog,
      "width": "400px",
      "append-to-body": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.showTableEditDialog = $event
      },
      "close": _vm.closeTableEditDialog
    }
  }, [(_vm.editingLineId != null) ? _c('el-form', {
    staticClass: "agreement-line-edit-form",
    attrs: {
      "label-width": "120px",
      "size": "small"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('pricingAgreements.minQty')
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "min": "1"
    },
    model: {
      value: (_vm.editingForm.min_qty_or_pack_qty),
      callback: function($$v) {
        _vm.$set(_vm.editingForm, "min_qty_or_pack_qty", _vm._n($$v))
      },
      expression: "editingForm.min_qty_or_pack_qty"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('pricingAgreements.discountPercent')
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "placeholder": "%"
    },
    model: {
      value: (_vm.editingForm.discount_percent),
      callback: function($$v) {
        _vm.$set(_vm.editingForm, "discount_percent", _vm._n($$v))
      },
      expression: "editingForm.discount_percent"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('pricingAgreements.discountAmt')
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "placeholder": _vm.$t('pricingAgreements.perUnit')
    },
    model: {
      value: (_vm.editingForm.discount_amount),
      callback: function($$v) {
        _vm.$set(_vm.editingForm, "discount_amount", _vm._n($$v))
      },
      expression: "editingForm.discount_amount"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('pricingAgreements.comment')
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 2,
      "placeholder": _vm.$t('pricingAgreements.comment')
    },
    model: {
      value: (_vm.editingForm.comment),
      callback: function($$v) {
        _vm.$set(_vm.editingForm, "comment", $$v)
      },
      expression: "editingForm.comment"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.closeTableEditDialog
    }
  }, [_vm._v(_vm._s(_vm.$t('pricingAgreements.cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.savingLine
    },
    on: {
      "click": function($event) {
        return _vm.saveLine(_vm.editingLineRow)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pricingAgreements.save')))])], 1)], 1), _vm._v(" "), (_vm.sortedFilteredAgreementLines.length > 0) ? _c('el-row', {
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('el-col', [_c('div', {
    staticClass: "pagination"
  }, [_c('v-pagination', {
    attrs: {
      "sizePerPage": _vm.perPage,
      "pagination": _vm.pagination,
      "switchFunction": _vm.onPageChange
    }
  })], 1)])], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-44385ccc","hasScoped":true}!./src/app/pages/withNavigation/pricingAgreements/edit/edit.html
// module id = 2985
// module chunks = 1